// jscpd:ignore-start
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import preferenceAction from '../../../actions/preference.action';
import useDispatch from '../../../hooks/useDispatch';
import { useMembership } from '../../../hooks/users';
import useSelector from '../../../hooks/useSelector';
import { STRATEGY_TAB_KEY } from '../../../modules/Insight/StockPageStatisticsTable';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
  GENERAL_DL_SWITCH_CLASS,
} from '../PriceViewer';
// jscpd:ignore-end

const NOPStrategySwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
  validStrategyList: string[];
}> = ({ wrapAnalytics, validStrategyList }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const hasMembership = useMembership();
  const { showNOPStrategy, NOPStrategyVersion } = useSelector(
    state => state.preference
  );

  return (
    <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
      <div
        className={classNames(GENERAL_DL_SWITCH_CLASS, {
          checked: showNOPStrategy,
          disabled: !hasMembership,
        })}
        onClick={wrapAnalytics('nop-strategy', () => {
          if (!showNOPStrategy) {
            dispatch(
              preferenceAction.setPriceViewerLabelType(STRATEGY_TAB_KEY)
            );
          }
          dispatch(
            preferenceActions.setPriceViewerNOPStrategy(!showNOPStrategy)
          );
        })}
        style={{ color: '#E8574D', fontWeight: 700 }}
      >
        {t('nop-strategy')}
      </div>
      {validStrategyList.map(interval => (
        <div
          key={interval}
          className={classNames(DL_SWITCH_CLASS_NAME, {
            checked: showNOPStrategy && NOPStrategyVersion === interval,
            disabled: !showNOPStrategy,
          })}
          onClick={wrapAnalytics(`nop-strategy-${interval}`, () => {
            dispatch(preferenceActions.setNOPStrategyVersion(interval));
          })}
        >
          {interval}
        </div>
      ))}
    </div>
  );
};

export default NOPStrategySwitch;
